import { Component, OnInit } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
  data: any;
  width:string;
}

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  data: any;
  width: string;
  url: string;

  constructor(public dialogService: DialogService) { 
    super(dialogService);
  }
  
  ngOnInit() {
    this.data = this.data;
    this.ViewReport();
  }

  ViewReport() {
    this.url = this.data.ReportUrl + '/offlineRpt.aspx?baseUrl=' + this.data.ReportUrl +
    '&reporturl=' + this.data.ReportPath + this.data.Parameters;
    if (this.data.InvNo) {
      this.url = this.data.ReportUrl + '/offlineRpt.aspx?baseUrl=' + this.data.ReportUrl + '&reporturl=' + this.data.ReportPath + '&LocId=' +
      this.data.LocId + '&InvNo=' + this.data.InvNo;
    }
    let iframe: any = document.getElementById('frame');
    iframe.contentDocument.location.reload(true);
  }

}
